<script>
	export let label = '';
	export let name = undefined;
	export let className = '';
	export let inputClass = '';
	export let labelClass = '';
	export let value = undefined;
	export let errors = [];

	// eslint-disable-next-line no-unused-vars
	$: props = (({ label, name, className, errors, onChange, value, ...rest }) => rest)($$props);
</script>

<div class={className}>
	{#if label}
		<label class="form-label {labelClass}" for={name}>{label}:</label>
	{/if}
	<!-- svelte-ignore a11y-no-onchange -->
	<select
		id={name}
		{name}
		{...props}
		disabled={props.readonly || props.disabled}
		on:change
		on:click|preventDefault
		class={'form-select focus:outline-none ' + inputClass}
		class:disabled={props.disabled}
		class:readonly={props.readonly}
		class:error={errors && errors.length}
		bind:value
	>
		<slot />
	</select>

	{#if errors && errors.length}
		<div class="form-error">{errors[0]}</div>
	{/if}
</div>
